<nz-form-item>
    @if (fieldLabel) {
    <nz-form-label [nzFor]="fieldId">{{ fieldLabel }}</nz-form-label>
    }
    <nz-form-control>
        <nz-input-group [nzAddOnAfter]="!idMode && upsertComponent && (isSearchPerformed || object) ? suffixActions : null" class="p-0">
            <!-- For returning full object -->
            @if (!idMode) {
            <nz-select
                #selectObject
                nzShowSearch
                nzServerSearch
                [nzAllowClear]="allowClear"
                [nzPlaceHolder]="fieldPlaceholder"
                [(ngModel)]="object"
                [nzShowArrow]="false"
                [ngModelOptions]="{ standalone: true }"
                [nzFilterOption]="nzFilterOption"
                (nzOnSearch)="search($event)"
                [nzDisabled]="disabled"
                (ngModelChange)="objectSelectionChanged($event)"
            >
                @for (o of listOfOption; track $index) {
                <nz-option [nzLabel]="o.text" [nzValue]="o.value"> </nz-option>
                }
            </nz-select>
            }

            <!-- For returning object.id -->
            @if (idMode) {
            <nz-select
                #selectId
                nzShowSearch
                nzServerSearch
                [nzAllowClear]="allowClear"
                [nzPlaceHolder]="fieldPlaceholder"
                [(ngModel)]="id"
                [nzShowArrow]="false"
                [ngModelOptions]="{ standalone: true }"
                [nzFilterOption]="nzFilterOption"
                (nzOnSearch)="search($event)"
                (ngModelChange)="idSelectionChanged($event)"
                [nzDisabled]="disabled"
            >
                @for (o of listOfOption; track o.value.id) {
                <nz-option [nzLabel]="o.text" [nzValue]="o.value.id"> </nz-option>
                }
            </nz-select>
            }
        </nz-input-group>
    </nz-form-control>
    <ng-template #suffixActions>
        @if (!disabled) {
            <nz-flex nzGap="small">
                @if (isSearchPerformed) {
                <button nz-button [nzSize]="'small'" [nzType]="'primary'" (click)="addObject()">
                    <i nz-icon nzType="plus" nzTheme="outline"></i>
                </button>
                } @if (object) {
                <button nz-button [nzType]="'primary'" [nzSize]="'small'" (click)="editObject()">
                    <i nz-icon nzType="edit" nzTheme="outline"></i>
                </button>
                } @if (object && allowClear) {
                <button nz-button nzDanger [nzType]="'primary'" [nzSize]="'small'" (click)="clearSelection()">
                    <i nz-icon nzType="minus" nzTheme="outline"></i>
                </button>
                }
            </nz-flex>
        }
    </ng-template>
</nz-form-item>
